var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import cs from 'classnames';
import { customizationsServiceThankBalanceCurrencyIconPathSelector } from 'common/services/customizations-service/service-store/selectors';
import { useCustomizationStore } from 'common/services/customizations-service/service-store/service-store';
import { Icon } from 'ui-kit/icon/icon';
import { ThanksBalanceIcon } from 'common/icons';
import { FILE_END_POINT } from 'common/constants/common';
import styles from './thanks-currency-icon.module.scss';
export var ThanksCurrencyIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 1.5 : _b, h = _a.height, className = _a.className, rest = __rest(_a, ["width", "height", "className"]);
    var thanksCurrencyIconPath = useCustomizationStore(customizationsServiceThankBalanceCurrencyIconPathSelector);
    var height = h || width;
    if (!thanksCurrencyIconPath)
        return (_jsx(Icon, __assign({}, rest, { withoutRtlMirroring: true, width: width, height: height, className: className, component: ThanksBalanceIcon })));
    return (_jsx("img", { className: cs(styles.thanksCurrencyIcon, className), src: "".concat(FILE_END_POINT, "/").concat(thanksCurrencyIconPath), style: __assign({ width: "".concat(width, "rem"), height: "".concat(height, "rem") }, rest.style) }));
};
